export const ACCOUNT_BELONG_OPTIONS = [
  { label: 'message.contact.own', value: '0' },
  { label: 'message.contact.others', value: '1' },
  { label: 'message.contact.vat', value: '2' },
];

export const ENTITY_TYPE_OPTIONS = [
  { label: 'message.contact.individual', value: '1' },
  { label: 'message.contact.business', value: '0' },
];

export const PAYMENT_METHOD_OPTIONS = [
  {
    label: 'LOCAL',
    value: '0',
  }, {
    label: 'SWIFT',
    value: '1',
  }, {
    label: 'BANK ACCOUNT',
    value: '2',
  }, {
    label: 'WALLET',
    value: '3',
  }, {
    label: 'CASH PICK-UP',
    value: '4',
  },
];

export const AUDIT_STATUS_OPTIONS = [
  { label: 'message.status.auditSuccess', value: 'pass' },
  { label: 'message.status.auditFail', value: 'fail' },
  { label: 'message.status.unaudited', value: 'waiting' },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { label: 'Checking', value: 'Checking' },
  { label: 'Saving', value: 'Saving' },
  { label: 'Ordinary', value: 'Ordinary' },
];

export const COUNTRY_PHONE_CODE_MAP = {
  BR: '+55',
  PH: '+63',
  TH: '+66',
  HK: '+852',
  VN: '+84',
  CA: '+1',
  US: '+1',
  CN: '+86',
  DE: '+49',
  EG: '+20',
  ES: '+34',
  FR: '+33',
  GB: '+44',
  ID: '+62',
  JP: '+81',
  KR: '+82',
  MX: '+52',
  MY: '+60',
  SA: '+966',
  AU: '+61',
};
